import { BasicConfig } from '@shared/models/basic-config.interface';

export abstract class CandidateAttachmentsConfig extends BasicConfig {
  privileges: {
    candidates: {
      resumes: 'web:candiadtes-resumes';
      files: 'web:candiadtes-files';
      filesReadOnly: 'web:candidates-files:read-only';
    };
  };
}

export type CandidateAttachmentsPrivileges = CandidateAttachmentsConfig['privileges'];
